import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BarChart, LineChart, PieChart } from 'echarts/charts';
import { DataZoomComponent, GridComponent, TitleComponent } from 'echarts/components';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { NgxEchartsDirective, NgxEchartsModule, provideEchartsCore } from 'ngx-echarts';

import { DrilldownChartNoDataAvailableModule } from '../drilldown-chart-no-data-available/drilldown-chart-no-data-available.module';
import { GroupedBarChartComponent } from './grouped-bar-chart.component';

use([
  CanvasRenderer,
  BarChart,
  LineChart,
  PieChart,
  GridComponent,
  TitleComponent,
  DataZoomComponent
]);

@NgModule({
  declarations: [GroupedBarChartComponent],
  exports: [GroupedBarChartComponent],
  imports: [
    CommonModule,
    DrilldownChartNoDataAvailableModule,
    NgxEchartsDirective,
    NgxEchartsModule.forRoot({
      echarts: {
        use
      }
    })
  ],
  providers: [
    provideEchartsCore({
      echarts: {
        use
      }
    })
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GroupedBarChartModule {}
